import { useEffect, useState } from "react";
import * as React from "react";
import { useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import StorageService from "../../../App/StorageService"
import { countryStateGetRequest } from "../../Authentication/SignUp/SignupServiceRequests"
import { LoadingAnimation, TooltipQuestionmark } from "../../Shared/Components/SvgIcons"
import Tooltip from "../../Shared/Primitive/Tooltip"
import { VectorDown, VectorUp } from "./SvgIcons"

function SearchableDropdown(
    props: {
        item?: null | string
        hasTooltip?: false | boolean
        tooltipContent?: any
        title?: null | string
        inSettingsModal?: null | boolean
        validationError: null | string
        setItemValue: Function
    } & React.HTMLAttributes<HTMLDivElement>
) {
    const [selected, setSelected] = useState("")
    const [isSelected, setIsSelected] = useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    let DropdownRef = React.useRef<HTMLInputElement>(null)
    let baseDropdownClass = props.inSettingsModal === true ? "dropdown__select-settings" : "dropdown__select"
    const translation = useSelector(selectTranslations)
    const [filter, setFilter] = useState("")
    const [statesArray, setStatesArray] = useState([{ country_code: "", postal_code: "", place_name: "" }])
    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {
        setFilter(props.item ? props.item : "")
        let isMounted = true
        countryStateGetRequest(filter)
            .then(response => {
                if (isMounted && response.status === 200) {
                    setStatesArray(response.data.items)
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.log(error.response)
            })
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        countryStateGetRequest(filter)
            .then(response => {
                if (response.status === 200) {
                    setStatesArray(response.data.items)
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.log(error.response)
            })
    }, [filter])

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLTextAreaElement>) => {
        setFilter(event.target.value)
        setIsDropdownOpen(true)
    }
    useEffect(() => {
        const onMouseDownHandler = (event: Event) => {
            if (isDropdownOpen && DropdownRef.current && !DropdownRef.current.contains(event.target as HTMLElement)) {
                setIsDropdownOpen(false)
            }
        }
        document.addEventListener("mousedown", onMouseDownHandler)
    })

    const onLocationClick = (value: string) => {
        setSelected(value)
        setIsSelected(true)
        props.setItemValue(value)
        setFilter(value)
        setIsDropdownOpen(false)
    }
    return isLoading ? (
        <div className="signup-form__loading-animation-container">
            <LoadingAnimation type="dropdown" />
        </div>
    ) : (
        <div className="dropdown" ref={DropdownRef} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            {props.hasTooltip && (
                <div className="single-text-input__text">
                    {props.title}
                    <div>
                        <Tooltip direction="settings-top" content={props.tooltipContent}>
                            <TooltipQuestionmark />
                        </Tooltip>
                    </div>
                </div>
            )}
            <div className={baseDropdownClass}>
                <input
                    className="dropdown__select-input"
                    placeholder={translation.chooseYourState}
                    value={filter}
                    onChange={onInputChange}
                    autoComplete="off"
                />
                <div className="dropdown__icon">{isDropdownOpen ? <VectorUp /> : <VectorDown />}</div>
            </div>
            {isDropdownOpen && (
                <div onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="dropdown__container">
                    <div className="dropdown__content">
                        {statesArray.map((state, index) => {
                            return (
                                <div>
                                    <div>

                                        <div
                                            key={ state.place_name+'-'+ state.postal_code}
                                            className={"dropdown__item dropdown__item--padding-left"
                                            }
                                            onClick={() => onLocationClick(state.place_name + " ("+ state.country_code +" - " + state.postal_code + ")")}
                                        >
                                            <p className="dropdown__text">{state.place_name} ({state.country_code} - {state.postal_code})</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
            <p className="accordion__error-message">{props.validationError}</p>
        </div>
    )
}
export default SearchableDropdown
